import * as BABYLON from 'babylonjs';
import * as BABYLONGUI from 'babylonjs-gui';
import VisualComponent from './VisualComponent';
import MediaManager from '@/api/MediaManager';

class Transition extends VisualComponent {
    getType() { return "Transition"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        let situation;
        for (let i = 0; i < context.situations.length; i++) 
            if(context.situations[i].id == prefab.getTargetID())
                situation = context.situations[i];
        
        //console.log("Transition construct...");
        super.setScaleFactor(0.2);
        const base = super.construct( context, prefab );

        var userLang = navigator.language || navigator.userLanguage; 
        if(userLang.includes("de"))
            this.mesh.material.emissiveTexture = MediaManager.getMedia(295144).getTexture();
        else
            this.mesh.material.emissiveTexture = MediaManager.getMedia(295137).getTexture();
        
        
        var ease = new BABYLON.CubicEase();

        this.mesh.actionManager = new BABYLON.ActionManager(this.scene);
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger,() => {
            var event = new CustomEvent("hideTransitionPreview");
            window.dispatchEvent(event);
            
           
            if(prefab.getTargetID() == 293932){            
                // window.open("https://192.168.178.20:8080/?sessionID=VML&situationID=293932", "_self");
                window.open("https://sales.flux-cms.de/Venjakob-Messe/?sessionID=VML&situationID=293932", "_self");
            }else if(prefab.getTargetID() == 295526){
                // window.open("https://192.168.178.20:8080/?sessionID=none&situationID=295526", "_self");
                window.open("https://sales.flux-cms.de/Venjakob-Messe/?sessionID=none&situationID=295526", "_self");
            }else if(prefab.getTargetID() == 300437){
                // window.open("https://192.168.178.20:8080/?sessionID=none&situationID=300437", "_self");
                window.open("https://sales.flux-cms.de/Venjakob-Messe/?sessionID=none&situationID=300437", "_self");
            }else{
                // Comit situation change
                let rotationAngles = prefab.getTargetRotation();
                if(rotationAngles)
                    rotationAngles = rotationAngles.toEulerAngles();
                context.$store.commit( 'handleGotoSituationTransition',  {               
                    situationID: prefab.getTargetID(), 
                    rotation: prefab.getTargetRotationOverwrite()==="true" ? rotationAngles : undefined
                }); 
            }
            
        }));
        
        // Hover-over animation
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger,() => {   
            BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One(), 0, ease);  
            window.dispatchEvent(new CustomEvent("hideTransitionPreview"));
        }));

        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger,() => {
            BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One().scale(1.1), 0, ease);
            var event = new CustomEvent("showTransitionPreview",{detail:{
                url: context.publicPath + "/media/" +context.panoramaTour.getName()+ "/" + situation.name.trim() + ".jpg",
                name: situation.name,
            }});
            window.dispatchEvent(event);
        }));
        return base;
    }

    createThumbnail(context,situation,base,prefab){
        //CREATE THUMBNAIL
        let texture = new BABYLON.Texture(context.publicPath + "/media/" +context.panoramaTour.getName()+ "/" + situation.name.trim() + ".jpg", context.scene);
        let name = "VisualComponentImage_"+prefab.getIconID();
        let thumbnail = BABYLON.MeshBuilder.CreatePlane(
            name, 
            {
                width: 50, 
                height: 25,
                sideOrientation: BABYLON.Mesh.DOUBLESIDE 
            }, context.scene);
        let thumbnailMaterial = new BABYLON.StandardMaterial(name + "_material", context.scene);
        thumbnailMaterial.emissiveTexture = texture;
        thumbnailMaterial.emissiveTexture.uScale = -1;
        thumbnailMaterial.emissiveTexture.vScale = 1;
        thumbnailMaterial.disableLighting = true;   
        thumbnailMaterial.opacityTexture = texture;
        thumbnailMaterial.opacityTexture.uScale = -1;
        thumbnailMaterial.opacityTexture.vScale = 1;
        thumbnailMaterial.emissiveTexture.hasAlpha = true;
        thumbnail.material = thumbnailMaterial;
        thumbnail.position.y = 30;
        thumbnail.position.z = -10;
        thumbnail.visibility = 0;

        //CREATE TEXT
        var plane = BABYLON.MeshBuilder.CreatePlane(
            "plane",{ 
                width: 60, 
                height: 60,
                sideOrientation: BABYLON.Mesh.DOUBLESIDE 
            },context.scene);
        plane.position.y = 40;
        plane.position.z = -15;
        plane.visibility = 0;
        
        var advancedTexture = BABYLONGUI.AdvancedDynamicTexture.CreateForMesh(plane);
        var text1 = new BABYLONGUI.TextBlock();
        text1.text = situation.name;
        text1.color = "white";
        text1.fontSize = 60;
        text1.drawOutline = true;
        text1.outlineColor = "black";
        text1.outlineWidth = 4;
        advancedTexture.addControl(text1);
        
        let thumbnailRoot = new BABYLON.TransformNode();
        thumbnailRoot.parent = base;
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function(){     
            BABYLON.Animation.CreateAndStartAnimation("hide", thumbnail, "visibility", 10,2, 1, 0, 0)          
            BABYLON.Animation.CreateAndStartAnimation("hide", plane, "visibility", 10, 2, 1, 0, 0)      
        }));
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function(){
            BABYLON.Animation.CreateAndStartAnimation("hide", thumbnail, "visibility", 10,2, 0, 1, 0)
            BABYLON.Animation.CreateAndStartAnimation("hide", plane, "visibility",10,2, 0, 1, 0)
        }));

        thumbnail.parent = thumbnailRoot;
        plane.parent = thumbnailRoot;
    }
}

export default Transition;
